import { Button, Grid, List, ListItemText, Table,  TableCell,  TableRow } from '@mui/material';
import styled, { css } from 'styled-components';

import { colorTheme, extraColor } from '@styles/muiTheme';
import { EAlertMessage } from '@modules/ContactManager/components/Tabs/components/Contact/interfaces';
import { ContactDetailsSection } from './HeaderStyles';

export const ContactAlertButton = styled(Button)<{ $messageColor: string }>`
  display: flex;
  height: 35px;
  margin: 0px 10px 4px 2px;
  border-radius: 18px;
  padding: 6px 9px !important;
  align-items: center;
  ${({ $messageColor }) => $messageColor === EAlertMessage.Green &&
  css`
      background: ${colorTheme.palette.success.light};
      color: ${colorTheme.palette.success.dark};
      &:hover {
        background: ${extraColor.palette.green.dark};
    }
  `}
  ${({ $messageColor }) => $messageColor === EAlertMessage.Red &&
  css`
      background: ${colorTheme.palette.error.light};
      color: ${colorTheme.palette.error.contrastText};
      &:hover {
        background: ${extraColor.palette.error.primary};
    }
  `}
  ${({ $messageColor }) => $messageColor === EAlertMessage.Orange &&
  css`
      background: ${extraColor.palette.orange.light};
      color: ${extraColor.palette.orange.dark};
      &:hover {
        background: ${extraColor.palette.orange.main};
    }
  `}
`;

export const ContactAlertList = styled(List)`
  padding: 0px;
  max-height: 300px;
  max-width: 450px;
`;

export const ContactAlertListItem = styled(ListItemText)(
  ({ isLastItem }: { isLastItem: boolean }) => `
    border-bottom: ${isLastItem ? `1px solid ${colorTheme.palette.secondary.main}` : ''};
    padding: 5px;
`);

export const CoApplicantTableRow = styled(TableRow)`
  padding: 3px 10px;
  background: ${colorTheme.palette.secondary.light};
  border-radius: 8px;
  margin-bottom: 5px;
  display: flex;
  align-items:center;
`;

export const CoApplicantTableCell = styled(TableCell)`
  border: none;
  min-width: 150px;
  flex: 1;
`;

export const CoApplicantName = styled.span`
  color: ${colorTheme.palette.primary.light};
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`;

export const LinkButton = styled.a`
	text-decoration: none;
	font-weight: 700;
	color: ${colorTheme.palette.primary.light};
`;

export const PhoneWrapper = styled.span`
	color: ${colorTheme.palette.primary.light};
  cursor: pointer;
`;

export const AddButton = styled.div`
  cursor: pointer;
  color: ${colorTheme.palette.info.dark};
  font-size: 14px;
  font-weight: 700;
`;

export const CreditScoreSection = styled.div`
  width: 330px;
  font-size: 14px;

  ${ContactDetailsSection} {
    border: none;
  }
`;

export const ModalHeaderInputs = styled.div`
  width: 330px;
  flex-direction: column;
  display: flex;
  gap: 10px;
  padding-top: 8px;

  .MuiFormControlLabel-root {
    height: 30px;
    margin-top: 5px;
  }
`;

export const CoApplicantModalHeader = styled.div`
  color: ${colorTheme.palette.common.white};
  display: flex;
  gap: 100px;
  padding: 20px 24px;
  margin: -8px -24px 20px -24px;
  min-height: 150px;
  background: transparent linear-gradient(270deg, ${colorTheme.palette.primary.dark} 0%, ${colorTheme.palette.primary.light} 100%) 0% 0% no-repeat padding-box;
`;

export const SingleRadioButtonWrapper = styled.div`
  cursor: pointer;

  input {
    scale: 1.3;
    margin-right: 10px;
  }

  label {
    cursor: pointer;
  }
`;

export const DataTableWrapper = styled.div<{ margin?: string }>`
  margin: ${({ margin }) => margin || '20px 0'};
`;

export const StyledTable = styled(Table)`
  tbody:before {
    content: "@";
    display: block;
    line-height: 15px;
    text-indent: -99999px;
  }
`;

export const DataTableLoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
`;

export const NoResultWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px 0;
  color: ${colorTheme.palette.common.black};
  font-weight: 600;
`;

export const DataTableHeaders = styled(TableRow)`
  background-color: ${colorTheme.palette.secondary.light};

  & th {
    font-weight: 600;
  }
`;

export const GridItemsWrapper = styled(Grid)`
  .MuiGrid-container .MuiGrid-item:nth-child(n+7) {
    padding-top: 0;
  }
`;
